module.exports = __webpack_public_path__ + "static/media/poweredbyaipass.5d7757cc.svg";